//Importaciones
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./file.css"; // Importa el archivo CSS

//Handler
const FileUploader = () => {
  //Estados locales
  const [file, setFile] = useState(null);
  const [metadata, setMetadata] = useState({});
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [jsonFile, setJsonFile] = useState(null)
  const [name, setName] = useState("")
  const [isLoading, setIsLoading] = useState(null)
  
  // Nuevos estados para fechas manuales
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  
  // Estado para el registro seleccionado
  const [selectedRecord, setSelectedRecord] = useState(null);
  
  //Formateo de fecha
  const formatDateToMs = (inputDate) => {
    // Validar que inputDate exista y sea una cadena válida
    if (!inputDate || typeof inputDate !== 'string') {
      console.warn('formatDateToMs: inputDate inválido:', inputDate);
      return '';
    }
    
    try {
      // Reemplazar 'T' por espacio y eliminar la 'Z'
      const formattedDate = inputDate.replace('T', ' ').replace('Z', '');
      // Agregar los milisegundos con 6 ceros
      return formattedDate.slice(0, -4) + '.000000';
    } catch (error) {
      console.error('Error en formatDateToMs:', error);
      return '';
    }
  }

  const formatDateToCustomString = (isoDate) => {
    // Validar que isoDate exista y sea una cadena válida
    if (!isoDate || typeof isoDate !== 'string') {
      console.warn('formatDateToCustomString: isoDate inválido:', isoDate);
      return '';
    }
    
    try {
      const partido = isoDate.split("T")
      if (partido.length !== 2) {
        console.warn('formatDateToCustomString: formato de fecha inválido:', isoDate);
        return '';
      }
      
      const fecha = partido[0]
      const time = partido[1].replace("Z", "")
      const [hours, minutes, seconds] = time.split(":").map(Number);
      
      // Validar que las horas, minutos y segundos sean números válidos
      if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
        console.warn('formatDateToCustomString: tiempo inválido en:', isoDate);
        return '';
      }
      
      // Determinar AM o PM
      const period = hours >= 12 ? "PM" : "AM";
      // Convertir las horas al formato de 12 horas
      const hours12 = hours % 12 === 0 ? 12 : hours % 12;
      const formattedTime = `${String(hours12).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
      // Formatear la fecha como "YYYY-MM-DD HH:mm:ss AM/PM"
      return `${fecha} ${formattedTime}`;
    } catch (error) {
      console.error('Error en formatDateToCustomString:', error);
      return '';
    }
  };

  const convertToLocalTime = (isoDate) => {
    // Validar que isoDate exista
    if (!isoDate) {
      console.warn('convertToLocalTime: isoDate inválido:', isoDate);
      return '';
    }
    
    try {
      // Crear un objeto Date desde la fecha en formato ISO
      const date = new Date(isoDate);
      
      // Validar que la fecha sea válida
      if (isNaN(date.getTime())) {
        console.warn('convertToLocalTime: fecha inválida:', isoDate);
        return '';
      }
      
      // Extraer los componentes de la fecha y hora en tu zona horaria
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // Formatear la fecha y hora en el formato deseado
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
      console.error('Error en convertToLocalTime:', error);
      return '';
    }
  };

  const formatDateToIdString = (isoDate) => {
    // Validar que isoDate exista
    if (!isoDate) {
      console.warn('formatDateToIdString: isoDate inválido:', isoDate);
      return '';
    }
    
    try {
      // Crear un objeto Date desde la fecha en formato ISO
      const date = new Date(isoDate);
      
      // Validar que la fecha sea válida
      if (isNaN(date.getTime())) {
        console.warn('formatDateToIdString: fecha inválida:', isoDate);
        return '';
      }
      
      // Extraer los componentes de la fecha y hora
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // Construir el string en el formato "YYYYMMDD_HHMMSS"
      return `${year}${month}${day}_${hours}${minutes}${seconds}`;
    } catch (error) {
      console.error('Error en formatDateToIdString:', error);
      return '';
    }
  };

  // Función para combinar fecha y hora en formato ISO
  const combineDateAndTime = (date, time) => {
    if (!date || !time) return "";
    return `${date}T${time}:00.000Z`;
  };

  // Función para calcular duración entre dos fechas
  const calculateDuration = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;
    const start = new Date(startDate);
    const end = new Date(endDate);
    return end.getTime() - start.getTime();
  };

  //Carga y metadatos de archivo
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    
    if (selectedFile) {
      setFile(selectedFile);
      
      // Extraer metadatos básicos del archivo
      const fileMetadata = {
        name: selectedFile.name,
        size: (selectedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        type: selectedFile.type,
        lastModified: new Date(selectedFile.lastModified).toISOString(),
      };
      
      setMetadata(fileMetadata);
    }
  };

  // Función para actualizar metadatos cuando cambien las fechas
  useEffect(() => {
    if (startDate && startTime && endDate && endTime) {
      const startDateTime = combineDateAndTime(startDate, startTime);
      const endDateTime = combineDateAndTime(endDate, endTime);
      
      if (startDateTime && endDateTime) {
        setMetadata(prev => ({
          ...prev,
          startDate: startDateTime,
          endDate: endDateTime,
          json_start: startDateTime,
          json_end: endDateTime
        }));
      }
    }
  }, [startDate, startTime, endDate, endTime]);

  //Función para generar JSON
  const generateJSONForFilteredRecords = (selectedRecord) => {
    if (!metadata.startDate || !metadata.endDate) {
      alert("Por favor, ingresa las fechas de inicio y final.");
      return;
    }

    // Validar que selectedRecord exista
    if (!selectedRecord || typeof selectedRecord !== 'object') {
      console.warn('generateJSONForFilteredRecords: registro seleccionado inválido:', selectedRecord);
      return;
    }

    // Validar que metadata tenga las propiedades necesarias
    if (!metadata.json_start || !metadata.json_end || !metadata.name) {
      console.warn('generateJSONForFilteredRecords: metadata incompleto:', metadata);
      alert("Por favor, asegúrate de que se haya cargado un archivo y configurado las fechas.");
      return;
    }

    // Validar que el registro seleccionado tenga las propiedades necesarias
    if (!selectedRecord.id || !selectedRecord.start_time || !selectedRecord.end_time) {
      console.warn('generateJSONForFilteredRecords: registro con propiedades faltantes:', selectedRecord);
      alert("El registro seleccionado no tiene todas las propiedades necesarias.");
      return;
    }

    // Calcular la duración del video (diferencia entre fechas configuradas)
    const durationMs = calculateDuration(metadata.json_start, metadata.json_end);
    
    // Usar la fecha y hora actual para el ID
    const currentDate = new Date();
    const id = formatDateToIdString(currentDate.toISOString());
    
    // Validar que el ID se haya generado correctamente
    if (!id) {
      console.error('generateJSONForFilteredRecords: No se pudo generar el ID');
      return;
    }
    
    // Crear la estructura del JSON
    const jsonData = {
      quantity: 1, //numero de videos
      raw_video_id: `${id}_${selectedRecord.id}`, // ID del video
      raw_video_start_time: convertToLocalTime(metadata.json_start).concat(".000000"), // Fecha y hora de inicio
      raw_video_end_time: convertToLocalTime(metadata.json_end).concat(".000000"), // Fecha y hora de fin
      duration: parseFloat(durationMs / 1000), // Duración en segundos
      fps: 120, // FPS del video
      training: false,
      experiments: [{
        id: selectedRecord.id,
        code: `${metadata.name.replace(/\.(mp4|mov)$/i, "")}_${selectedRecord.id}`,
        ground_truth: selectedRecord.ground_truth || 0, // Valor de ground_truth, por defecto 0 si no existe
        harvester: selectedRecord.harvester || '', // Valor por defecto si no existe
        start_time: formatDateToMs(selectedRecord.start_time), // Fecha y hora de inicio del registro
        end_time: formatDateToMs(selectedRecord.end_time) // Fecha y hora de fin del registro
      }]
    };
    
    // Definir el nombre del archivo
    const fileName = `${id}_${selectedRecord.id}.json`;
    
    // Guardar el JSON como archivo
    setJsonFile({
      name: fileName,
      content: jsonData
    });
    
    // Usar el mismo ID para el nombre del video
    setName(`${id}_${selectedRecord.id}`);
    
    console.log(`Archivos generados con ID: ${id}`);
    console.log(`- Video: ${id}.mp4`);
    console.log(`- JSON: ${id}.json`);
  };

  //Función para traer todos los registros
  const fetchRecords = async () => {
    if (!metadata.startDate || !metadata.endDate) {
      alert("Asegúrate de ingresar las fechas de inicio y final.");
      return;
    }
    
    try {
      console.log("Obteniendo registros del endpoint...");
      const response = await axios.get(
        "https://legne6zwh1.execute-api.us-east-1.amazonaws.com/v1/weights/all"
      );
      
      // Validar que la respuesta tenga la estructura esperada
      if (!response.data || !response.data.body || !Array.isArray(response.data.body.data)) {
        console.error('fetchRecords: Estructura de respuesta inválida:', response.data);
        alert("La respuesta del servidor no tiene el formato esperado.");
        return;
      }
      
      const filtered = response.data.body.data.filter((record) => {
        // Validar que el registro tenga las propiedades necesarias
        if (!record || typeof record !== 'object') {
          console.warn('fetchRecords: registro inválido:', record);
          return false;
        }
        
        if (!record.start_time || !record.end_time) {
          console.warn('fetchRecords: registro sin fechas:', record);
          return false;
        }
        
        try {
          const apiStart = new Date(record.start_time).toISOString();
          const apiEnd = new Date(record.end_time).toISOString();
          
          // Validar que las fechas sean válidas
          if (isNaN(new Date(apiStart).getTime()) || isNaN(new Date(apiEnd).getTime())) {
            console.warn('fetchRecords: fechas inválidas en registro:', record);
            return false;
          }
          
          const convertToUTC0 = (dateString) => {
            const date = new Date(dateString);
            const timezoneOffset = date.getTimezoneOffset() * 60 * 1000;
            const utcTimestamp = date.getTime() + timezoneOffset;
            return new Date(utcTimestamp).toISOString();
          };
          
          const inicio = convertToUTC0(apiStart);
          const final = convertToUTC0(apiEnd);
          
          // Comparar las fechas
          const isApiStartInRange = inicio >= metadata.startDate && inicio <= metadata.endDate;
          const isApiEndInRange = final >= metadata.startDate && final <= metadata.endDate;
          
          // Resultado final
          return isApiStartInRange && isApiEndInRange;
        } catch (error) {
          console.error('fetchRecords: Error procesando registro:', error, record);
          return false;
        }
      });
      
      console.log(`Se encontraron ${filtered.length} registros en el rango de fechas`);
      
      // Los registros ya vienen con hacienda_nombre, ingenio_nombre y suerte
      // No necesitamos hacer llamadas adicionales a las APIs
      setFilteredRecords(filtered);
    } catch (error) {
      console.error("Error al obtener registros:", error);
      alert("Ocurrió un error al obtener los registros.");
    }
  };

  useEffect(() => {
    // Solo ejecutar si hay un registro seleccionado Y metadata completo
    if (selectedRecord && 
        metadata.json_start && 
        metadata.json_end && 
        metadata.name) {
      generateJSONForFilteredRecords(selectedRecord);
    }
  }, [selectedRecord, metadata.json_start, metadata.json_end, metadata.name, generateJSONForFilteredRecords]);

  //Función carga de archivo - video
  const uploadFile = async () => {
    setIsLoading(true);
    
    if (!file) {
      alert("Selecciona un archivo para subir.");
      return;
    }
    
    if (!metadata.startDate || !metadata.endDate) {
      alert("Por favor, ingresa las fechas de inicio y final.");
      setIsLoading(null);
      return;
    }
    
    try {
      console.log("Solicitando URL prefirmada...");
      const response = await axios.post(
        "https://legne6zwh1.execute-api.us-east-1.amazonaws.com/v1/assets/load",
        {
          body: {
            key: `videos_prueba/${name}.mp4`,
            contentType: file.type,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      const res = response.data;
      const body = JSON.parse(res.body);
      const url = body.signedUrl;
      
      console.log("Subiendo archivo a S3...");
      const uploadResponse = await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      });
      
      if (uploadResponse.status < 300) {
        alert("Archivo subido exitosamente!");
        setIsLoading(null);
        window.location.reload();
      } else {
        alert("Error al subir el archivo.");
        setIsLoading(null);
      }
    } catch (err) {
      console.error("Error durante la carga:", err);
      alert("Ocurrió un error durante la carga.");
      setIsLoading(null);
    }
  };

  //Función carga de archivo - json
  const uploadJSON = async () => {
    if (!jsonFile) {
      if (selectedRecord) {
        generateJSONForFilteredRecords(selectedRecord);
      } else {
        alert("Por favor, selecciona un registro primero.");
        return;
      }
    }
    
    try {
      console.log("Solicitando URL prefirmada...");
      const response = await axios.post(
        "https://legne6zwh1.execute-api.us-east-1.amazonaws.com/v1/assets/load",
        {
          body: {
            key: `json_prueba/${jsonFile.name}`,
            contentType: "json",
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      const res = response.data;
      const body = JSON.parse(res.body);
      const url = body.signedUrl;
      
      console.log("Subiendo archivo a S3...");
      const json = jsonFile;
      
      const uploadResponse = await axios.put(url, json, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      
      if (uploadResponse.status < 300) {
        console.log("Archivo subido exitosamente!");
      } else {
        console.log("Error al subir el archivo.");
      }
    } catch (err) {
      console.error("Error durante la carga:", err);
      alert("Ocurrió un error durante la carga.");
    }
  };

  const handleButtonClick = () => {
    fetchRecords();
    // El JSON se generará automáticamente cuando se seleccione un registro
  };

  //Renderizado
  return (
    <div className="container">
      <div className="imagenes">
        <img className="imagenPrincipal" src="https://res.cloudinary.com/dfmsezslx/image/upload/v1734564047/logocenicana_jxy8tx.png" alt="Logo Cenicaña"></img>
        <img className="imagenSecundaria" src="https://res.cloudinary.com/dfmsezslx/image/upload/v1734637659/powerby_znidqs.png" alt="Logo Tecde"></img>
      </div>
      
      <h2 className="title">Cargar videos de experimentos en campo</h2>
      <h3 className="subtitle">Procesa los videos de los experimentos para estimar calidad de crote y peso</h3>
      
      <input
        type="file"
        onChange={handleFileChange}
        accept="video/*"
        className="fileInput"
      />
      
      <p className="fileHelpText">
        <strong>Selecciona un video recortado</strong> que muestre únicamente el momento cuando la caña pasa por el elevador para estimar peso y calidad.
      </p>
      
      {file && (
        <div className="metadataContainer">
          <h3 className="subtitle">Metadatos del archivo</h3>
          <p>
            <strong>Nombre:</strong> {metadata.name || 'N/A'}
          </p>
          <p>
            <strong>Tamaño:</strong> {metadata.size || 'N/A'}
          </p>
          <p>
            <strong>Tipo:</strong> {metadata.type || 'N/A'}
          </p>
          <p>
            <strong>Última modificación:</strong>{" "}
            {metadata.lastModified ? new Date(metadata.lastModified).toLocaleString() : 'N/A'}
          </p>
          <p className="fileReadyMessage">
            ✅ <strong>Archivo seleccionado y listo para procesar</strong>
          </p>
        </div>
      )}

      {/* Campos para fechas manuales */}
      <div className="dateInputContainer">
        <h3 className="subtitle">Configurar rango de fechas</h3>
        
        <div className="dateRow">
          <div className="dateColumn">
            <label htmlFor="startDate">Fecha de inicio:</label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="dateInput"
            />
          </div>
          
          <div className="timeColumn">
            <label htmlFor="startTime">Hora de inicio:</label>
            <input
              type="time"
              id="startTime"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              className="timeInput"
            />
          </div>
        </div>
        
        <div className="dateRow">
          <div className="dateColumn">
            <label htmlFor="endDate">Fecha de final:</label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="dateInput"
            />
          </div>
          
          <div className="timeColumn">
            <label htmlFor="endTime">Hora de final:</label>
            <input
              type="time"
              id="endTime"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              className="timeInput"
            />
          </div>
        </div>
        
        {metadata.duration && (
          <p className="durationInfo">
            <strong>Duración calculada:</strong> {metadata.duration}
          </p>
        )}
      </div>

      {isLoading && (
        <div className="loaderContainer">
          <div className="spinner"></div>
          <p className="loadingText">Cargando...</p>
          <p className="loadingText">Esto puede tardar unos minutos por el tamaño del video</p>
        </div>
      )}

      <button 
        disabled={!file || !metadata.startDate || !metadata.endDate || !selectedRecord}
        onClick={() => {
          uploadFile();
          uploadJSON();
        }}
        className={(!file || !metadata.startDate || !metadata.endDate || !selectedRecord) ? "uploadButtonDisabled" : "uploadButton"}>
        Subir archivo
      </button>

      {/* Aviso sobre el recorte del video */}
      <div className="videoWarning">
        <h4 className="warningTitle">⚠️ Importante</h4>
        <p className="warningText">
          <strong>El video debe estar recortado en el momento de interés:</strong><br/>
          Específicamente cuando la caña pasa por el elevador para estimar peso y calidad.
          Asegúrate de que el rango de fechas configurado corresponda exactamente a este momento.
        </p>
      </div>

      {metadata.startDate && metadata.endDate && (
        <button
          onClick={handleButtonClick}
          className="uploadButton">
          Verificar registros en rango
        </button>
      )}

      {/* Mensaje cuando se están cargando los registros */}
      {filteredRecords.length === 0 && metadata.startDate && metadata.endDate && (
        <div className="noRecordsMessage">
          <h4 className="noRecordsTitle">🔍 No se encontraron registros</h4>
          <p className="noRecordsText">
            No se encontraron experimentos en el rango de fechas especificado:<br/>
            <strong>Desde:</strong> {formatDateToCustomString(metadata.startDate)}<br/>
            <strong>Hasta:</strong> {formatDateToCustomString(metadata.endDate)}
          </p>
          <p className="noRecordsSuggestion">
            <strong>Sugerencias:</strong>
          </p>
          <ul className="noRecordsSuggestions">
            <li>Verifica que el rango de fechas sea correcto</li>
            <li>Intenta con un rango de fechas más amplio</li>
            <li>Asegúrate de que las fechas correspondan a experimentos registrados</li>
          </ul>
        </div>
      )}

      {filteredRecords.length > 0 && (
        <div className="recordsContainer">
          <h3 className="subtitle">Experimentos en rango ({filteredRecords.length} encontrados)</h3>
          
          {/* Mensaje de error de red si existe */}
          {filteredRecords.some(record => 
            (record.ingenio_nombre && record.ingenio_nombre.includes('Error')) ||
            (record.hacienda_nombre && record.hacienda_nombre.includes('Error'))
          ) && (
            <div className="entitiesErrorWarning">
              <h4 className="entitiesErrorTitle">⚠️ Advertencia</h4>
              <p className="entitiesErrorText">
                Algunos nombres de ingenio o hacienda no se pudieron cargar debido a problemas de red.
                Los registros se muestran con la información disponible.
              </p>
            </div>
          )}
          
          {/* Lista de registros para seleccionar */}
          <div className="recordsList">
            {filteredRecords
              .sort((a, b) => new Date(a.start_time) - new Date(b.start_time))
              .map((record, index) => (
                <div 
                  key={index} 
                  className={`recordItem ${selectedRecord && selectedRecord.id === record.id ? 'selected' : ''}`}
                  onClick={() => setSelectedRecord(record)}
                >
                  <div className="recordHeader">
                    <span className="recordId">ID: {record.id.substring(0, 8)}</span>
                    <button 
                      className={`selectButton ${selectedRecord && selectedRecord.id === record.id ? 'selected' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedRecord(record);
                      }}
                    >
                      {selectedRecord && selectedRecord.id === record.id ? '✓ Seleccionado' : 'Seleccionar'}
                    </button>
                  </div>
                  <div className="recordTimes">
                    <span>Inicio: {formatDateToCustomString(new Date(record.start_time).toISOString())}</span>
                    <span>Fin: {formatDateToCustomString(new Date(record.end_time).toISOString())}</span>
                  </div>
                  
                  {/* Información adicional de Ingenio, Hacienda, Suerte, Variedad de Caña, Parcela y Máquina */}
                  <div className="recordEntities">
                    {record.ingenio_nombre && (
                      <span className="entityTag ingenio">
                        🏭 {record.ingenio_nombre}
                      </span>
                    )}
                    {record.hacienda_nombre && (
                      <span className="entityTag hacienda">
                        🌾 {record.hacienda_nombre}
                      </span>
                    )}
                    {record.suerte && (
                      <span className="entityTag suerte">
                        🎯 {record.suerte}
                      </span>
                    )}
                    {record.variety_cane && (
                      <span className="entityTag variety">
                        🎋 {record.variety_cane}
                      </span>
                    )}
                    {record.parcela && (
                      <span className="entityTag parcela">
                        🗺️ {record.parcela}
                      </span>
                    )}
                    {record.harvest && (
                      <span className="entityTag harvest">
                        🚜 {record.harvest}
                      </span>
                    )}
                  </div>
                </div>
              ))}
          </div>

          {/* Información detallada del registro seleccionado */}
          {selectedRecord && (
            <div className="selectedRecordInfo">
              <h4 className="subtitle">Registro Seleccionado</h4>
              <div className="recordDetails">
                <p><strong>ID Completo:</strong> {selectedRecord.id}</p>
                <p><strong>Hora de inicio:</strong> {formatDateToCustomString(new Date(selectedRecord.start_time).toISOString())}</p>
                <p><strong>Hora de final:</strong> {formatDateToCustomString(new Date(selectedRecord.end_time).toISOString())}</p>
                
                {/* Información de Ingenio */}
                {selectedRecord.ingenio_nombre && (
                  <p>
                    <strong>Ingenio:</strong> {selectedRecord.ingenio_nombre}
                  </p>
                )}
                
                {/* Información de Hacienda */}
                {selectedRecord.hacienda_nombre && (
                  <p>
                    <strong>Hacienda:</strong> {selectedRecord.hacienda_nombre}
                  </p>
                )}
                
                {/* Información de Suerte */}
                {selectedRecord.suerte && (
                  <p>
                    <strong>Suerte:</strong> {selectedRecord.suerte}
                  </p>
                )}
                
                {/* Información de Variedad de Caña */}
                {selectedRecord.variety_cane && (
                  <p>
                    <strong>Variedad de Caña:</strong> {selectedRecord.variety_cane}
                  </p>
                )}
                
                {/* Información de Parcela */}
                {selectedRecord.parcela && (
                  <p>
                    <strong>Parcela:</strong> {selectedRecord.parcela}
                  </p>
                )}
                
                {/* Información de Máquina (Harvest) */}
                {selectedRecord.harvest && (
                  <p>
                    <strong>Máquina:</strong> {selectedRecord.harvest}
                  </p>
                )}
                
                {selectedRecord.ground_truth && (
                  <p><strong>Ground Truth:</strong> {selectedRecord.ground_truth}</p>
                )}
                {selectedRecord.harvester && (
                  <p><strong>Harvester:</strong> {selectedRecord.harvester}</p>
                )}
                
                {/* Mostrar todas las propiedades del registro para debugging */}
                <details className="recordDebug">
                  <summary>Ver todas las propiedades del registro</summary>
                  <pre>{JSON.stringify(selectedRecord, null, 2)}</pre>
                </details>
              </div>
            </div>
          )}

          {/* Mostrar el JSON generado */}
          {jsonFile && (
            <div className="jsonPreviewContainer">
              <h4 className="subtitle">Archivo JSON Generado</h4>
              <div className="jsonPreview">
                <p><strong>Nombre del archivo:</strong> {jsonFile.name}</p>
                <details className="jsonDebug">
                  <summary>Ver contenido del JSON</summary>
                  <pre>{JSON.stringify(jsonFile.content, null, 2)}</pre>
                </details>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FileUploader;

